/* istanbul ignore file */
import { createSelector } from 'reselect'

export const driverSelector = (state) => state && state.driver

export const driverDataSelector = createSelector(
    driverSelector,
    (driver) => driver.data || {}
)
